import React, { FC } from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import { MONTHS } from '../../../lib/constants';
import { GenericSelect } from '../GenericSelect/GenericSelect';

interface Props extends WithTranslation {
	placeholder: string;
	error?: string;
	// options: GenericSelectValue[],
	selectedValue: string;
	dataCy?: string;
	dateType: 'day' | 'month' | 'year';
	defaultDate?: Date;
	setSelectedValue(value: string): void;
	additionalInputParams?: any;
	onlyRange?: boolean;
	addYear?: boolean;
}

const DateSelect: FC<Props> = (props) => {
	const getMonthsSelectValues = () => {
		const monthSelectValues: any[] = [];
		let monthNumber = 1;
		for (const month of MONTHS) {
			monthSelectValues.push({
				value: String(monthNumber).padStart(2, '0'),
				label: props.t('common.months.' + month),
			});
			monthNumber++;
		}

		return monthSelectValues;
	};
	const getYearSelectValues = () => {
		const yearSelectValues: any[] = [];
		let firstYear = props.defaultDate
			? props.defaultDate.getFullYear()
			: new Date().getFullYear();
		if (props.addYear)
			firstYear = firstYear+1;
		const startYear = props.onlyRange ? firstYear-4 : 1920;
		for (let year = firstYear; year > startYear; year--) {
			yearSelectValues.push({ value: year, label: year });
		}

		return yearSelectValues;
	};

	const getDaysSelectValues = () => {
		const daysSelectValues: any[] = [];
		for (let day = 1; day <= 31; day++) {
			daysSelectValues.push({
				value: String(day).padStart(2, '0'),
				label: day,
			});
		}

		return daysSelectValues;
	};

	let selectOptions: any[];

	switch (props.dateType) {
		case 'day':
			selectOptions = getDaysSelectValues();
			if (props.defaultDate && !props.selectedValue) {
				props.setSelectedValue(
					String(props.defaultDate.getDate()).padStart(2, '0')
				);
			}
			break;

		case 'month':
			selectOptions = getMonthsSelectValues();
			if (props.defaultDate && !props.selectedValue) {
				props.setSelectedValue(
					String(props.defaultDate.getMonth() + 1).padStart(2, '0')
				);
			}
			break;

		case 'year':
			selectOptions = getYearSelectValues();
			if (props.defaultDate && !props.selectedValue) {
				props.setSelectedValue(String(props.defaultDate.getFullYear()));
			}
			break;

		default:
			selectOptions = [];
	}

	return (
		<GenericSelect
			placeholder={props.placeholder}
			error={props.error}
			options={selectOptions}
			selectedValue={props.selectedValue}
			setSelectedValue={props.setSelectedValue}
			dataCy={props.dataCy}
			additionalInputParams={props.additionalInputParams}
		/>
	);
};

const translatedDateSelect = withTranslation('translation')(DateSelect);
export default translatedDateSelect;
